<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings/pos-settings"></ion-back-button>
    </ion-buttons>
    <ion-title>Taxes</ion-title>

    <ion-buttons slot="end">
      <ion-button 
        (click)="createTax()">
        <ion-icon name="add"></ion-icon>            
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask>

  <salonmonster-tap-retry *ngIf="errorOccured" (click)="loadTaxes()"></salonmonster-tap-retry>

  <ng-container *ngIf="!isLoading && !errorOccured">
    <ion-row>
      <ion-col class="hidden-sm-down"></ion-col>

      <ion-col size="12" size-sm="12" size-md="8" size-lg="8" size-xl="8">

        <ion-item *ngIf='taxes.count() == 0'>
          <div class="no-taxes">No Taxes</div>
        </ion-item>

        <ion-list *ngIf='taxes.count() > 0'>
          <ion-list-header>Salon taxes</ion-list-header>
          <ion-item
            class="tax"
            *ngFor="let tax of taxesCopy; let taxIndex = index;"
            (click)="onTaxEditHandler(tax, taxIndex)">
            {{ tax.name }}
            <div slot="end">
              {{ tax.rateString }}
            </div>
          </ion-item>
        </ion-list>
      </ion-col>

      <ion-col class="hidden-sm-down"></ion-col>
    </ion-row>
  </ng-container>
</ion-content>
